import jStat from 'jstat';
import sum from 'lodash/sum';
import { round6 } from 'utilities/math';

const transpose = a => {
  return a[0].map((_, c) => {
    return a.map(r => {
      return r[c];
    });
  });
};

const calculateExpectedFrequency = (rowLength, columnLength, rowTotalArr, columnTotalArr, n) => {
  const expectedFrequencyArr = new Array(rowLength).fill(0).map(() => new Array(columnLength).fill(0));
  for (let i = 0; i < rowLength; i++) {
    for (let j = 0; j < columnLength; j++) {
      expectedFrequencyArr[i][j] = (round6(rowTotalArr[i] * (columnTotalArr[j] / n)));
    }
  }
  return expectedFrequencyArr;
};

export const calculateTableDataForChiSquareTestForIndependence = (dataSet, parameter) => {
  const [data] = (Object.values(dataSet[0]));
  const n = data.count;
  const observed = data.levels;
  const levelNames = observed.map(item => item.name);
  const levelColumnNames = observed[0].levels.map(item => item.name);
  const observedCount = observed.map(item => item.count);
  const levelCounts = observed.map(item => {
    return item.levels.map(level => level.count);
  });

  const transposedLevelsCountArr = transpose(levelCounts);

  const observedCountColumnsValues = transposedLevelsCountArr.map(item =>
    item.reduce((acc, curVal) => acc + curVal)
  );

  const expectedFrequencies = calculateExpectedFrequency(levelNames.length, levelColumnNames.length, observedCount, observedCountColumnsValues, n);

  const contributionsToChiSquare = levelCounts.map((observedRow, i) =>
    observedRow.map((observedValue, j) =>
      round6((observedValue - expectedFrequencies[i][j]) ** 2 / expectedFrequencies[i][j]))
  );
  return ({
    expectedFrequencies,
    levelNames,
    levelColumnNames,
    observedCount,
    observedCountColumnsValues,
    contributionsToChiSquare,
    categoryName: parameter,
    levelCounts
  });
};

export const calculateChiSquareTestForIndependence = (dataSet, parameter, chiSquareArray) => {
  const [data] = (Object.values(dataSet[0]));
  const n = data.count;
  const df = (data.levels.length - 1) * (data.levels[0].levels.length - 1);
  const chiSquare = round6(sum(chiSquareArray));
  let pValue = round6(1 - jStat.chisquare.cdf(chiSquare, df));
  if (!pValue) {
    pValue = '< 0.00001';
  }
  return ({
    n,
    df,
    pValue,
    chiSquare
  });
};
